import { backendDomain } from "../modules/configs";
import {
  RECEIVED_PRINTED_MODELS_INFO_OVERRIDE, ERROR_ON_GETTING_PRINTED_MODELS, START_FETCHING_PRINTED_MODELS,
  UPDATE_TOGGLE_LIST_OF_PRINT_ITEMS, RECEIVED_PRINTED_MODELS_INFO_APPEND, TOGGLE_PRINT_FILTER, CHANGE_DATE_FILTER_START,
  CHANGE_DATE_FILTER_END, CHANGE_MODEL_NAME_FILTER, SEARCH_PRINT_RECORDS_BY_EMAIL, CHANGE_SEARCH_EMAIL,
  CLEAR_PRINTED_MODELS_INFO, INIT_LOADING_AND_HASMORE_STATUS, ERROR_ON_GETTING_PRINT_RECORD, CLEAR_ERROR,
  START_SEARCHING_PRINT_RECORDS
} from "./types";
import axios from 'axios';
export const DATE_FILTER = {
  START: 'start',
  END: 'end'
}

export const startFetchingPrintedModelsWithinSpanThenAppendOrOverride = (endTimeStamp, startTimeStamp, append) => dispatch => {
  dispatch({ type: START_FETCHING_PRINTED_MODELS })
  let requestParams = ``;
  if (endTimeStamp) {
    requestParams += `endTimeStamp=${endTimeStamp}`;
  }
  if (startTimeStamp) {
    requestParams += `startTimeStamp=${startTimeStamp}`;
  }
  const getPrintedModelsEndpoint = `${backendDomain}/query/models?${requestParams}`;
  return axios.get(getPrintedModelsEndpoint, { headers: { Authorization: `Bearer ${localStorage.access_token}` } }).then(res => {
    const recordListOfPrintedModels = res.data;
    dispatch(receivedPrintedModelsInfo(recordListOfPrintedModels, append));
  })
    .catch(err => {
      dispatch(errorOnGettingPrintedModels(err))
    })
}

export const searchPrintRecordsByEmailWithinSpanThenAppendOrOverride = (endTimeStamp,  email, append) => dispatch => {
  dispatch({ type: START_FETCHING_PRINTED_MODELS })
  const getPrintedModelsEndpoint = `${backendDomain}/record/queryPrintRecordByEmail?${endTimeStamp === undefined ? "" : `endTimeStamp=${endTimeStamp}`}`;
  return axios.post(getPrintedModelsEndpoint, { email }, { headers: { Authorization: `Bearer ${localStorage.access_token}` } }).then(res => {
    const recordListOfPrintedModels = res.data;
    dispatch(receivedPrintedModelsInfo(recordListOfPrintedModels, append));
  })
    .catch((err) => {
      const error = err.response
      console.log(error)
      dispatch(errorOnGettingPrintRecord(error))
    })
}


const receivedPrintedModelsInfo = (printedModels, append) => {
  let type = RECEIVED_PRINTED_MODELS_INFO_APPEND
  if (!append) {
    type = RECEIVED_PRINTED_MODELS_INFO_OVERRIDE
  }
  return {
    type: type,
    payload: { printedModels }
  }
}

const errorOnGettingPrintedModels = error => ({
  type: ERROR_ON_GETTING_PRINTED_MODELS,
  payload: { error }
})

const errorOnGettingPrintRecord = error => ({
  type: ERROR_ON_GETTING_PRINT_RECORD,
  payload: { error }
})

export const updateToggleListOfPrintItems = (togglesOfPrintRecordItems) => ({
  type: UPDATE_TOGGLE_LIST_OF_PRINT_ITEMS,
  payload: { togglesOfPrintRecordItems }
})

export const toggleFilter = () => ({
  type: TOGGLE_PRINT_FILTER
})

export const changeDateFilter = (date, which) => {
  if (which === DATE_FILTER.START) {
    return {
      type: CHANGE_DATE_FILTER_START,
      payload: { date }
    }
  }
  else if (which === DATE_FILTER.END) {
    return {
      type: CHANGE_DATE_FILTER_END,
      payload: { date }
    }
  }
}

export const changeModelNameFilter = modelName => ({
  type: CHANGE_MODEL_NAME_FILTER,
  payload: { modelName }
})

export const changeSearchEmail = email => ({
  type: CHANGE_SEARCH_EMAIL,
  payload: { email }
})

export const clearModelInfolist = () => ({
  type: CLEAR_PRINTED_MODELS_INFO
})

export const startSearchingPrintRecords = () => ({
  type: START_SEARCHING_PRINT_RECORDS
})

export const initloadingAndHasMore = () => ({
  type: INIT_LOADING_AND_HASMORE_STATUS
})

export const searchPrintRecordsByEmail = () => ({
  type: SEARCH_PRINT_RECORDS_BY_EMAIL
})

export const clearError = () => ({
  type: CLEAR_ERROR
})


// WEBPACK FOOTER //
// ./src/actions/getPrintedModels.js